import { render, staticRenderFns } from "./LaboratoryView.vue?vue&type=template&id=8807e712"
import script from "./LaboratoryView.vue?vue&type=script&lang=js"
export * from "./LaboratoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports